import { render, staticRenderFns } from "./h-minor-banner.vue?vue&type=template&id=8520809c&scoped=true"
import script from "./h-minor-banner.vue?vue&type=script&lang=js"
export * from "./h-minor-banner.vue?vue&type=script&lang=js"
import style0 from "./h-minor-banner.vue?vue&type=style&index=0&id=8520809c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8520809c",
  null
  
)

export default component.exports